import axios from "axios";
import axiosClient from "../axiosClient";

const route = "/api/organization";

export const getOrganizationSubscriptions = async (params = {}) => {
  try {
    const response = await axiosClient.get(`${route}/getAllSubs`, {
      params: {
        ...params,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const createOrganizationSubscription = async (organizationId, data) => {
  console.log("Creating subscription for organization:", organizationId);
  try {
     const token = localStorage.getItem("token");
    const response = await axios.post(`${process.env.REACT_APP_URL}/organizationSubscription`, {
        ...data,
    }, {
      headers: {
        organizationid: organizationId,
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const updateOrganizationSubscription = async (id, data) => {
  try {
    const response = await axiosClient.put(`organizationSubscription/${id}`, {
      ...data,
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};


